/** Sort `items` by their id's position in `order`. Ids not present in `order`
 *  keep their original relative position, after all ordered ones. Stable. Used
 *  by the sidebar lists, whose per-entry order the user sets by drag-reorder
 *  (persisted in settings + backed up). */
export function orderByIds<T>(items: T[], order: string[], getId: (t: T) => string): T[] {
  if (order.length === 0) return items;
  const rank = new Map(order.map((id, i) => [id, i] as const));
  return items
    .map((it, i) => ({ it, i }))
    .sort((a, b) => {
      const ra = rank.get(getId(a.it));
      const rb = rank.get(getId(b.it));
      if (ra === undefined && rb === undefined) return a.i - b.i;
      if (ra === undefined) return 1;
      if (rb === undefined) return -1;
      return ra - rb;
    })
    .map((x) => x.it);
}
